import { useEffect, useRef, useState } from 'react';
import { Tabs } from 'antd';
import { HistoryOutlined, InfoCircleOutlined } from '@ant-design/icons';
import UserHistoryList from './UserHistoryList';
import UserDetails from './UserDetails';
import { UserHistoryProvider } from '../../contexts/data/users/UserHistoryContext';
import UserDoc from '../../../domain/models/UserDoc';
import { useSearchParams } from 'react-router-dom';
import UserFilesList from './UserFilesList';
import { UserFilesProvider } from '../../contexts/data/users/UserFilesContext';

const TAB_KEYS = {
    informations: 'informations',
    history: 'history',
    files: 'files',
}

interface UserTabsProps {
    selected: UserDoc;
}

export default function UserTabs({ selected: user }: UserTabsProps) {
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState(searchParams.get('tab') ?? TAB_KEYS.informations);

    const scrollToSendMailRef = useRef(false);

    const handleTabChange = (key: string) => {
        setActiveTab(key);
        setSearchParams({ tab: key });
    };

    const scrollToSendMailSection = () => {
        document.getElementById('user-send-mail-section')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    useEffect(() => {
        if (!scrollToSendMailRef.current || activeTab !== TAB_KEYS.informations) {
            return;
        }
        scrollToSendMailRef.current = false;
        requestAnimationFrame(() => scrollToSendMailSection());
    }, [activeTab]);

    return <Tabs
        defaultActiveKey={activeTab}
        activeKey={activeTab}
        onChange={handleTabChange}
        items={[
            {
                key: TAB_KEYS.informations,
                label: 'Informations',
                icon: <InfoCircleOutlined />,
                children: <UserDetails user={user} />,
            },
            {
                key: TAB_KEYS.history,
                label: 'Historique',
                icon: <HistoryOutlined />,
                children: <UserHistoryProvider>
                    <UserHistoryList user={user} />
                </UserHistoryProvider>,
            },
            {
                key: TAB_KEYS.files,
                label: 'Fichiers',
                icon: <HistoryOutlined />,
                children: <UserFilesProvider>
                    <UserFilesList user={user} />
                </UserFilesProvider>,
            },
        ]}
    />
}